export enum TestIds {
  CompletedBy = 'CompletedBy',
  ImpactId = 'ImpactId',
  Likelihood = 'Likelihood',
  RatedItemId = 'RatedItemId',
  Ratings = 'Ratings',
  TestDate = 'TestDate',
}
